import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { PopupModule } from '@progress/kendo-angular-popup';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { ButtonModule, ButtonsModule } from '@progress/kendo-angular-buttons';
import { Kno2SearchComponent } from './kno2-search.component';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { GridModule } from '@progress/kendo-angular-grid';

@NgModule({
  imports: [
    CommonModule,
    DialogsModule,
    PopupModule,
    TranslateModule,
    InputsModule,
    ReactiveFormsModule,
    LayoutModule,
    ButtonModule,
    ButtonsModule,
    DropDownsModule,
    GridModule
  ],
  declarations: [
    Kno2SearchComponent
  ],
  exports: [
    Kno2SearchComponent
  ]
})
export class Kno2SearchModule { }
